import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App, Button } from "antd";
import { api, unwrap } from "@/api/client";
import { useErrorText } from "@/api/errors";
import { useAuth } from "@/auth/AuthProvider";
import { useI18n } from "@/i18n";

/**
 * "Pakai HPP sekarang": units sold or written off before their SKU had a cost
 * take today's cost (open periods only), so reports stop counting them at 0.
 * Shown beside the warnings about those units, for finance managers.
 */
export function FillCostsButton() {
  const { t, formatNumber } = useI18n();
  const { can } = useAuth();
  const { message } = App.useApp();
  const errorText = useErrorText();
  const queryClient = useQueryClient();
  const fill = useMutation({
    mutationFn: () => unwrap(api.POST("/v1/finance/costs/fill-missing")),
    onSuccess: (r) => {
      const n = (v: number) => formatNumber(v);
      const done = r.soldUnits + r.countedUnits;
      const parts = [done > 0 ? t("fillCost.done", { sold: n(r.soldUnits), counted: n(r.countedUnits) }) : t("fillCost.none")];
      if (r.openUnits > 0) parts.push(t("fillCost.open", { n: n(r.openUnits) }));
      if (r.closedUnits > 0) parts.push(t("fillCost.closed", { n: n(r.closedUnits) }));
      void (done > 0 ? message.success(parts.join(" "), 8) : message.warning(parts.join(" "), 8));
      for (const key of ["finance", "books"]) void queryClient.invalidateQueries({ queryKey: [key] });
    },
    onError: (err) => void message.error(errorText(err)),
  });
  if (!can("finance.manage")) return null;
  return (
    <Button size="small" loading={fill.isPending} onClick={() => fill.mutate()}>
      {t("fillCost.button")}
    </Button>
  );
}
